import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Container, Row, Col, Label, Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useConsentimiento } from '../../../hooks/tomaMuestra/useConsentimiento';
import { useLogin } from '../../../hooks/tomaMuestra/useLogin';
import { sendRequest } from '../../../hooks/requests/useRequest';
import { useEncuestaCliente } from '../../../hooks/tomaMuestra/useEncuestaCliente';
import '../../../assets/css/pantalla1.css'
import '../../../assets/css/cartaConsentimiento.css'
import DeniReactTreeView from "deni-react-treeview"
import { ModalAccept } from './ModalAccept';
import { useSweetAlert } from '../../../hooks/sweetAlerts/useSweetAlert';
import { Card } from 'primereact/card';
import avatarHombre from '../../../assets/images/user/hombre.png';
import avatarMujer from '../../../assets/images/user/mujer.png';
import { Avatar } from 'primereact/avatar';
import { Dialog } from 'primereact/dialog';
import Select from 'react-select';







export const IndexSamplingForm = () => {

  const {
    saveUpdateTmSample, saveUpdateTmSampleCancell,
    typeModalCancellation, modal5, toggle5, handleInputChangeCancellation,
    handleModalCancellToma, loading, comments, handleInputChangeComment,
    //refused sample patient
    id_cancellation_reazon_sample, handleSelectValuesR, reason, validationsSG, //sample
    handleSample, toggle6, flebotomiaRefused, modal6
  } = useEncuestaCliente();

  const { hour, minute, second } = useConsentimiento();

  const { time, reload, dataCancellation } = useLogin();

  const { nimm, id_sample } = useParams();
  let name2 = localStorage.getItem('flebotomisaNombre');
  let name5 = localStorage.getItem('willson');
  let maquila = localStorage.getItem('maquila');

  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(true);
  const themes = ['green']
  const [itemsTree, setItemsTree] = useState([]);
  const treeviewRef = useRef(null);
  const [patien, setPatien] = useState("");
  const [idGender, setIdGender] = useState(0);
  const [idP, setIdP] = useState(0);
  const [loadin, setLoadin] = useState(false);
  const [nim, setNim] = useState("");
  const [pendingSample, setPendingSample] = useState([]);
  const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()
  const [idBranch, setIdBranch] = useState(0);
  const [age, setAge] = useState("");


  //#region SAMPLINGS

  useEffect(() => {

    if (nimm !== undefined) {
      getDataFromNimPost(nimm)
    }
  }, [nimm]);


  // ==========================================
  // INICIO DE NUEVO CÓDIGO: BLOQUEO DE GESTO "ATRÁS"
  // ==========================================
  useEffect(() => {
    // 1. Forzamos una entrada nueva en el historial al montar el componente
    window.history.pushState(null, null, window.location.href);

    const handlePopState = (event) => {
      // 2. El usuario hizo el gesto de regresar (swipe o botón atrás) en la tablet
      // Volvemos a empujar el estado para mantenerlo "atrapado" en esta vista
      window.history.pushState(null, null, window.location.href);

      // 3. Mostramos la alerta de SweetAlert para explicarle por qué no pasó nada
      createSweet(
        "warning",
        "Acción no permitida",
        "Navegación bloqueada",
        "Para evitar perder la información de la toma de muestra, por favor utiliza los botones de la pantalla."
      );
    };

    // Escuchamos el evento de navegación del historial
    window.addEventListener('popstate', handlePopState);

    // Evitar que el usuario recargue la página por accidente (F5 o swipe hacia abajo)
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ''; // Necesario para la mayoría de navegadores modernos
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // 4. Limpieza: Se ejecuta cuando el componente muere (para no afectar otras pantallas)
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); // El array vacío equivale a ponerlo en el constructor o Page_Load de C#
  // ==========================================
  // FIN DE NUEVO CÓDIGO
  // ==========================================



  const getDataFromNimPost = async (nimm) => {

    setLoadin(false)
    let _newForm = {
      nim: nimm.substring(0, 13),
      id_departament: localStorage.getItem('depW')
    }
    let _listTmp = await handleRequest("POST", "Sass/GetDataFromPatient", "Sample", _newForm);


    if (_listTmp !== null) {
      setLoadin(true);

      let nim = _listTmp.lista_pruebas;

      let _isToma = await handleRequest("GET", `Sample/DetailSample/${nim[0].nim}`, 'sample');

      let is_toma = _isToma[0];
      let validateToma = is_toma.finallyFech;
      let _idWorkOrder = 0;
      let _namePatient = "";
      let _idgender = 0;
      let _arrayNuevo = [];
      let _nimPatient = ""
      let _idBranch = 0;
      let _age = "";

      _listTmp.lista_pruebas.forEach(_find => {
        _idWorkOrder = _find.id_work_order
        _namePatient = _find.name_patient
        _idgender = _find.gender
        _nimPatient = _find.nim
        _idBranch = _find.id_brach
        _age = _find.age

        _arrayNuevo.push({
          "profiles": _find.listProfile,
          "exams": _find.listExam,
          "is_toma": _isToma.length > 0 && validateToma !== '' ? _isToma : ''
        })

        let tree = createTree(_arrayNuevo);
        setItemsTree(tree);
      });

      setPatien(_namePatient);
      setIdGender(_idgender);
      setIdP(_idWorkOrder);
      setNim(_nimPatient);
      setIdBranch(_idBranch);
      setAge(_age);
    }
  }



  const createTree = (_arrayNuevo) => {

    let _tree = [];

    _arrayNuevo.forEach(_find => {


      if (_find.exams.length > 0) {

        _find.exams.forEach(_e => {

          let _exam_Curve = [];

          if (_e.is_curve) {
            _e.arrayCurvesSampling.forEach((_curve) => {

              _exam_Curve.push({
                id: _curve.id_work_order_sticker ?? 0,
                isLeaf: _curve.is_toma_curv,
                state: _curve.is_complete ? 1 : 2,
                text: _curve.barcode ?? "-----",
                is_toma: _curve.is_toma_curve ?? false,
                id_work_order_sticker: _curve.id_work_order_sticker,
                id_work_order_exam: _curve.id_work_order_exam,
                check_forwarded: _e.check_forwarded,
                is_curve: _e?.is_curve,
                id_work_order: _e.id_work_order,
                is_complete: _curve.is_complete,
              });

            });
          }

          _tree.push({
            expanded: true,
            children: _e?.is_curve ? _exam_Curve : [],
            id: _e.id_work_order_exam,
            id_work_order: _e.id_work_order,
            id_exam: _e.id_exam,
            state: _e.refused_check_specimen === false ? 1 : 2,
            text: _e.name,
            isLeaf: _e.check_specimen,
            refused_check_specimen: _e.refused_check_specimen,
            check_forwarded: _e.check_forwarded,
            is_toma: _e.refused_check_specimen === false ? _find.is_toma : '',
            is_curve: _e?.is_curve
          });

        });
      }


      if (_find.profiles.length > 0) {

        _find.profiles.forEach(_p => {

          let examenes_aux = [];

          _p.listExam.forEach((_e) => {

            examenes_aux.push({
              id: _e.id_work_order_exam,
              id_work_order: _e.id_work_order,
              id_exam: _e.id_exam,
              isLeaf: _e.check_specimen,
              state: _e.refused_check_specimen === false ? 1 : 2,
              text: _e.name,
              refused_check_specimen: _e.refused_check_specimen,
              check_forwarded: _e.check_forwarded,
              is_toma: _e.refused_check_specimen === false ? _find.is_toma : ''
            });

          });

          const allCompleted = examenes_aux.every(ex => ex.state === 1);

          _tree.push({
            children: examenes_aux,
            state: allCompleted ? 1 : 2,
            text: _p.name_profile,
            is_toma: _find.is_toma,
            check_forwarded: false,
            refused_check_specimen: false
          });

        });

      }

    });

    return _tree;
  };






  const onRenderItem = (_find) => {
    return (
      <div
        className="treeview-item-example"
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%"
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {
            _find.state === 1 && _find.check_forwarded === false ?
              <span style={{ color: "#51bb25" }}>
                <i className="icofont icofont-laboratory f-12"></i>
                {_find.text}
              </span>
              :
              _find.state === 1 && _find.check_forwarded === true ?
                <span>
                  <i className="icofont icofont-laboratory f-12"></i>
                  {_find.text}
                </span>
                :
                <span style={{ color: '#FF8F00' }}>
                  <i
                    style={{ color: '#FF8F00' }}
                    className="icofont icofont-laboratory f-12"
                  ></i>
                  {_find.text}
                </span>
          }
        </div>

        <ul
          style={{
            display: "flex",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "1 px"
          }}
        >
          {renderStatusLabel(_find)}
        </ul>
      </div>
    );
  };



  const changeTree = (e) => {
    changeStatus(e)
  }

  const changeStatus = async (e) => {

    const api = treeviewRef.current.api
    const items = api.getItems();

    let pending2 = [];

    items.forEach(_find => {
      console.log("🚀 ~ changeStatus ~ _find:", _find)
      ////console.log(_find);
      if (_find.id !== undefined) {
        ////console.log("pasa aqui..............");
        if (_find.state === 2 && _find.check_forwarded == false) {
          pending2.push({
            "id_work_order": idP,
            "id_work_order_exam": _find.id,
            "list_refusedTracking": [
              {
                //"refused_check_specimen": true,
                "refused_check_specimen": _find.is_toma !== '' ? false : _find.state === 2 ? true : false,
                "text": _find.text
              }
            ]
          });
        }
        if (_find.state === 1 && _find.check_forwarded === false) {//modifica aqui esta parte
          pending2.push({
            "id_work_order": idP,
            "id_work_order_exam": _find.id,
            "entra": 0,
            "list_refusedTracking": [
              {
                "refused_check_specimen": false,
                "text": _find.text
                // "refused_check_specimen": _find.state === 2 ? true : false
              }
            ]
          });
        }//modifique aqui no
      }
      //profiles
      else {
        _find.children.forEach(ex => {
          console.log("🚀 ~ changeStatus ~ ex:", ex)

          if (ex.state === 2 && ex.check_forwarded === false) {
            pending2.push({
              "id_work_order": idP,
              "id_work_order_exam": ex.id,
              "list_refusedTracking": [
                {
                  //"refused_check_specimen": true,
                  "refused_check_specimen": ex.is_toma !== '' ? false : ex.state === 2 ? true : false


                }
              ]
            });
          }

          if (ex.state === 1 && ex.check_forwarded === false) {
            pending2.push({
              "id_work_order": idP,
              "id_work_order_exam": ex.id,
              "entra": 0,
              "list_refusedTracking": [
                {
                  "refused_check_specimen": false,
                  "text": _find.text
                  // "refused_check_specimen": ex.state === 2 ? true : false
                }
              ]
            });
          }
        })
      }
    });
    setPendingSample(pending2)
  }

  const savePendingMuestra = async () => {

    let listTmp = await handleRequest("POST", "Sass/RefusedSample2", "Sample", pendingSample);
    if (listTmp !== null) {
    }
  }



  const saveReload = async (studies) => {
    let analytes = [];


    studies.forEach((item) => {
      if (item.children && item.children.length > 0) {
        item.children.forEach((child) => {

          if (child.is_curve) {
            if (child.is_complete) {
              return;
            }
            analytes.push({
              id_work_order: child.id_work_order,
              id_work_order_exam: child.id_work_order_exam,
              text: item.text + " " + "/" + " " + child.text,
              check: child.state,
              check_forwarded: child.check_forwarded,
              is_toma: child.is_toma,
              id_work_order_sticker: child.id_work_order_sticker,
              is_curve: child.is_curve,
              id_sample: id_sample,
              is_complete: child.is_complete

            });
          }
          else {
            analytes.push({
              id_work_order: child.id_work_order,
              id_work_order_exam: child.id,
              text: child.text,
              check: child.state,
              check_forwarded: child.check_forwarded,
              is_toma: child.is_toma,
              is_curve: false
            });
          }
        });
      } else {
        analytes.push({
          id_work_order: item.id_work_order,
          id_work_order_exam: item.id,
          text: item.text,
          check: item.state,
          check_forwarded: item.check_forwarded,
          is_toma: item.is_toma,
          is_curve: false
        });
      }
    });




    const selectedStudies = analytes.filter(item => item.is_curve ? (item.check === 2 && item.is_toma === false) : (item.check === 2 && item.is_toma === ''));
    console.log("🚀 ~ saveReload ~ analytes:", analytes)
    let confirmMessage = "";
    let alert = "";

    if (selectedStudies.length === 0) {
      confirmMessage = "¿Está seguro que desea concluir la toma de muestra con todos los estudios seleccioandos?";
      alert = "success"
    } else {
      const examListText = selectedStudies.map(item => `• ${item.text}`).join('\n');
      alert = "warning"



      confirmMessage = `
    ¿Está seguro de que desea concluir la toma de muestra con los siguientes estudios pendientes?
    <ul style="color:red; font-weight:bold;">
      ${examListText}
    </ul>
  `;
    }


    const isConfirmed = await sweetAcceptGlobal(
      confirmMessage,
      "",
      alert,
      true
    )

    if (isConfirmed) {
      if (maquila === true || maquila === "true") {
        processMaquila(studies);
      }

      sampleProcess(analytes);
      savePendingMuestra();
      saveUpdateTmSample();
    }
  };



  const sampleProcess = async (analytes) => {
    let listTmp = await handleRequest("POST", "Sample/SampleProcess", "Sample", analytes);
  }

  const processMaquila = async (studies) => {
    let maquilaExams = await handleRequest("GET", `ExamBranchesMaquila/List/${idBranch}`)
    let _listExams = studies;
    let _foundNotMaquila = [];

    _listExams.forEach((item, index) => {
      if (item.state === 1) {
        let _children = item.children;

        let foundMaquilaExam = maquilaExams.find(x => x.id_exam === item.id_exam);

        if (foundMaquilaExam === undefined) {
          _foundNotMaquila.push({
            "id_work_order": item.id_work_order,
            "id_work_order_exam": item.id
          });
        }

        _children.forEach((child, IChild) => {
          if (child.state === 1) {
            let foundChild = maquilaExams.find(x => x.id_exam === child.id_exam);

            if (foundChild === undefined) {
              _foundNotMaquila.push({
                "id_work_order": child.id_work_order,
                "id_work_order_exam": child.id
              });
            }
          }
        })
      }
    })


    let processMaquila = await handleRequest("POST", "Sample/ProcessMaquila", "Sample", _foundNotMaquila)



  }

  const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
    let requestOptions = {
      method: method
    };

    if (body !== null) {
      requestOptions = {
        ...requestOptions,
        body: JSON.stringify(body)
      };
    }

    const response = await sendRequest(requestOptions, methodUrl);

    if (response.code === 200) {
      return response.data;
    }
    else if (response.code === 404) {
      createSweet("info", "info", "Atención", response.data.msg);
    }
    else if (response.code === 500) {
    }
    else {
    }
    return null;
  }

  const avatarImage = idGender === 2 ? avatarHombre : avatarMujer;

  const renderStatusLabel = (_find) => {

    let background = "#FFE0B2";
    let color = "#E65100";
    let text = "Sin muestra";
    let animate = false;
    let status = "warning";

    if (_find.state === 1 && _find.check_forwarded === false) {
      background = "#E8F5E9";
      color = "#2E7D32";
      text = "Con muestra";
      status = "success";
    }

    if (_find.state === 1 && _find.check_forwarded === true) {
      background = "#E3F2FD";
      color = "#1565C0";
      text = "Remitida";
      status = "forwarded";
    }

    if (_find.state !== 1) {
      animate = true;
    }

    return (
      <div
        style={{
          background,
          color,
          fontSize: "11px",
          fontWeight: 600,
          padding: "4px 12px",
          borderRadius: "20px",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          minWidth: "120px",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          animation: animate ? "pulseSoft 3s ease-in-out infinite" : "none"
        }}
      >
        {status === "warning" && (
          <i
            className="pi pi-exclamation-triangle"
            style={{ color: "#E65100", fontSize: "13px" }}
          />
        )}

        {status === "success" && (
          <i
            className="pi pi-verified"
            style={{ color: "#2E7D32", fontSize: "13px" }}
          />
        )}

        {status === "forwarded" && (
          <i className="icofont icofont-user"
            style={{ color: "#1565C0", fontSize: "13px" }}></i>
        )}



        {text}
      </div>
    );
  };







  const titlePatient = <>
    <Col sm="12">
      <Row>
        <Col sm="5">

        </Col>
        <Col sm="5" style={{ textAlign: "start" }} >
          <h5>Estudios a realizar</h5>
        </Col>
      </Row>
      <Col sm="12" style={{ textAlign: "center" }}>
        <Avatar image={avatarImage} size="xlarge" shape="circle" />
      </Col>
      <Col sm="12">
        <Row>
          <Col sm="3">
            <label style={{ fontSize: "12px" }} >Nombre <br /> {patien ?? "---"} </label>
          </Col>
          <Col sm="2">
            <label style={{ fontSize: "12px" }} >Nim <br /> {nimm ?? "---"} </label>
          </Col>
          <Col sm="1">
            <label style={{ fontSize: "12px" }} >Edad <br /> {age ?? "---"} </label>
          </Col>
          <Col sm="2">
            <label style={{ fontSize: "12px" }} >sexo <br /> {idGender === 2 ? "Masculino" : "Femenino"} </label>
          </Col>
          <Col sm="4">
            <label style={{ fontSize: "15px" }}>Comentario del flebotomista</label>
          </Col>
        </Row>
      </Col>
    </Col>
  </>















  return (
    <Fragment>
      <Container fluid={true} >
        <Col xs="12" sm="12" md="12" lg="12" xl="12" className='p-l-0 p-r-0' >
          <Row>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="p-l-1"> <br />
              <div className='box-departamento'>
                <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ textAlign: "-webkit-center" }}>
                  <Row>
                    <Col xs="2" sm="2" md="2" lg="2" xl="2" >
                      <Label className='labelToma1'>{time}</Label>
                    </Col>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1" >
                    </Col>

                    <Col xs="6" sm="6" md="6" lg="6" xl="6"  >
                      <label className="labelToma1">Toma de Muestra</label>
                    </Col>

                    <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-1' style={{ textAlign: "-webkit-right" }}>
                      {
                        show1 ? (<label className='rc'>{hour}:{minute}:{second}</label>) : ""
                      }
                    </Col>
                    <Col sm="1" md="1" lg="1" xl="1" className='pt-1' style={{ textAlign: "justify" }} >
                      {
                        show1 ? (<img className="" style={{ width: "38%" }} src={require("../../../assetsToma/imagenes/Cronometro.png")} alt="Cronometro" />
                        ) : ""
                      }
                    </Col>
                  </Row>
                </Col>
              </div>
            </Col>

            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="p-l-0 p-r-0"  >

              <Col xs="12" sm="12" md="12" lg="12" xl="12" >
                {
                  loadin === false ?
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center p-l-0 p-r-0'>
                      <Card className='shadow'>
                        <Row className='mt-2'> <br />
                          <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center'>  <br /> <br /> <br /> <br />
                            <img src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '130px' }} />
                          </Col>
                        </Row>
                        <Row className='mt-2'>
                          <Col xs="3" sm="3" md="3" lg="3" xl="3" className='text-center'></Col>
                          <Col xs="2" sm="2" md="2" lg="2" xl="2" className='text-left p-r-0'>
                            <p className='f-18 text-primary animate__animated animate__pulse animate__infinite'> <b>Cargando</b></p>
                          </Col>
                          <Col xs="1" sm="1" md="1" lg="1" xl="1" className='text-center'>
                            <br />
                            <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                          </Col>
                          <Col xs="1" sm="1" md="1" lg="1" xl="1" className='text-center'>
                            <br />
                            <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle f-14"></i></p>
                          </Col>
                          <Col xs="1" sm="1" md="1" lg="1" xl="1" className='text-center'>
                            <br />
                            <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                          </Col>
                          <Col sm="2" md="2" lg="2" className='text-center'></Col>
                        </Row>
                      </Card>
                    </Col>
                    :
                    <Col sm="12">
                      <Row>
                        <Col sm="12">
                          <Card title={titlePatient}>
                            <Col sm="12">
                              <Row>
                                <Col sm="1">
                                </Col>
                                <Col sm="6">
                                  <DeniReactTreeView
                                    ref={treeviewRef}
                                    style={{
                                      marginRight: '10px',
                                      marginBottom: '10px',
                                      height: "200px",
                                      width: "100%",
                                      textAlign: "left",
                                      border: "2px solid #1f4e69",
                                      borderRadius: "10px"
                                    }}
                                    className="tree-estudios"
                                    showCheckbox={true}
                                    showIcon={false}
                                    items={itemsTree}
                                    selectRow={false}
                                    onRenderItem={onRenderItem}
                                    theme={themes}
                                    onCheckItem={(e) => changeTree(e)}
                                  />
                                </Col>
                                <Col sm="4">
                                  <textarea
                                    name='comments'
                                    value={comments}
                                    onChange={handleInputChangeComment}
                                    style={{
                                      marginRight: '10px',
                                      marginBottom: '10px',
                                      height: "200px",
                                      width: "100%",
                                      textAlign: "center",
                                      border: "2px solid #1f4e69",
                                      borderRadius: "10px",
                                      fontSize: "14px"
                                    }}
                                  />
                                </Col>
                                <Col sm="1">
                                </Col>

                              </Row>
                            </Col>


                          </Card>
                        </Col>

                      </Row>
                    </Col>



                }

              </Col>

              <Col xs="12" sm="12" md="12" lg="12" xl="12" className="pt-2" style={{ textAlign: "-webkit-center" }}>
                <button className='button-samplingForm' onClick={() => saveReload(itemsTree)} >Finalizar Toma</button>


              </Col>
            </Col >
          </Row>
          <Col style={{ position: 'fixed', right: 0, bottom: 0, zIndex: 5, width: '250px', height: '380px', borderTopLeftRadius: '12px', padding: '10px' }} className='divMenu p-l-0'>
            {
              show ?
                (
                  ""
                )
                :
                (
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <div className='username-Active ' >
                      <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Row>
                          <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-l-0 p-r-0 p-0' style={{ textAlign: "-webkit-center" }} >
                            <br />
                            <i className="fa fa-circle icon-active-small"></i>
                          </Col>
                          <Col xs="10" sm="10" md="10" lg="10" xl="10" className='p-l-0 p-r-0'> <br />
                            <label className='r-label-active p-0 ' >{name2}</label>
                          </Col>
                        </Row>
                      </Col>
                    </div> <br />
                    <div className='username-Active pointer'>
                      <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Row>
                          <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}> <br />
                            <img className=" " src={require("../../../assetsToma/imagenes/Recargar.png")} style={{ width: "40%" }} alt="" />
                          </Col>
                          <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 ' onClick={reload} > <br />
                            <label className='r-label-active p-0 pointer'>{"Recargar"}</label>
                          </Col>
                        </Row>
                      </Col>
                    </div> <br />
                    <div className='username-Active pointer' onClick={() => { setShow1(!show1); }}>
                      <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Row>
                          <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}> <br />
                            <img className=" " src={require("../../../assetsToma/imagenes/Cronometro.png")} style={{ width: "45%" }} alt="" />
                          </Col>
                          <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 '> <br />
                            <label className='r-label-active p-0 pointer'>{"Cronómetro"}</label>
                          </Col>
                        </Row>
                      </Col>
                    </div><br />
                    <div className='username-Active pointer' onClick={handleModalCancellToma} >
                      <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Row>
                          <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}> <br />
                            <img className=" " src={require("../../../assetsToma/imagenes/CerrarBlanco.png")} style={{ width: "29%" }} alt="" />
                          </Col>
                          <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 '> <br />
                            <label className='r-label-active p-0 pointer' >{"Cancelar Toma"}</label>
                          </Col>
                        </Row>
                      </Col>
                    </div> <br />
                  </Col>
                )
            }
          </Col>



        </Col>
        <div className='tap-top' style={{ display: "block" }} onClick={() => { setShow(!show) }}><i className="icon-angle-double-up f-24"></i>
        </div>


        <br /><br /><br /><br />
      </Container>
      <Dialog
        header="Rechazar toma de muestra "
        visible={modal5}
        headerStyle={{
          backgroundColor: "#bd2130",
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: "#bd2130", color: 'white' } },
          headerIcon: { style: { color: 'white' } },
        }}
        onHide={toggle5}
        className="large-dialog-sample"
        footer={
          <>
            {
              <Button
                size="sm"
                color="danger"
                type="button"
                onClick={() => saveUpdateTmSampleCancell()}
              >
                {"Aceptar"}
              </Button>
            }
            <Button
              size="sm"
              type="button"
              color="secondary"
              className="btn-air-light"
              onClick={toggle5}
            >
              {"Cancelar" ?? "---"}
            </Button>
          </>
        }
      >
        <Col sm="12" className="pt-2 p-l-0 p-r-0 ">
          {/* <Messages ref={msgs} /> */}


          <div
            style={{
              backgroundColor: "#fff8e1",
              border: "1px solid #ffe9a8",
              padding: "10px 14px",
              borderRadius: "8px",
              color: "#8a6d3b",
              fontSize: "0.85rem",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
            }}
          >
            <i
              className="fa fa-exclamation-circle"
              style={{ color: "#d39e00", fontSize: "18px" }}
            />
            Selecciona el motivo para rechazar esta toma de muestra
          </div>

          <div style={{ marginTop: "12px" }}>
            <Select
              classNamePrefix="select"
              name="id_cancellation_reazon_sample"
              value={id_cancellation_reazon_sample}
              options={reason}
              onChange={(e) => handleSelectValuesR(e, "id_cancellation_reazon_sample")}
              isClearable={true}
              placeholder="Selecciona un motivo..."
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  borderColor: "#cbd5e1",
                  padding: "2px",
                  minHeight: "42px",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#94a3b8",
                  },
                }),
                option: (base, state) => ({
                  ...base,
                  padding: "10px 14px",
                  fontSize: "0.9rem",
                  backgroundColor: state.isSelected
                    ? "#3b82f6"
                    : state.isFocused
                      ? "#e2e8f0"
                      : "white",
                  color: state.isSelected ? "white" : "#334155",
                  cursor: "pointer",
                }),
              }}
            />
          </div>
          <Col sm="12" className="mt-4 p-l-0 p-r-0"  >
            <div
              style={{
                backgroundColor: 'white', border: '1px solid #e0e0e0',
                borderRadius: '10px', padding: '12px', fontSize: '12px'
              }}
              className="shadow-sm"
            >
              <div>
                <span style={{ fontWeight: "600", color: "#475569" }}>Paciente:</span>{" "}
                <span style={{ color: "#334155" }}>{patien}</span>
              </div>

              <div className="mt-1">
                <span style={{ fontWeight: "600", color: "#475569" }}>NIM:</span>{" "}
                <span style={{ color: "#334155" }}>{nim}</span>
              </div>

              <div>
                <span style={{ fontWeight: "600", color: "#475569" }}>Motivo de rechazo:</span>{" "}
                <span className='f-w-600' style={{ color: "#334155" }}>{id_cancellation_reazon_sample !== null ? id_cancellation_reazon_sample.label ?? "----" : null}</span>
              </div>
            </div>
          </Col>
        </Col>
      </Dialog >



      <ModalAccept
        {
        ...{
          handleSample, toggle6, flebotomiaRefused, modal6, pendingSample,
          name2, name5, patien, nim
        }
        }

      />
    </Fragment>
  )
}
